module.exports = __webpack_public_path__ + "static/media/t4.632a15b3.jpg";